import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import "./trade-view-button-container.css";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import axios from "axios";
import AuthContext from "../../../../../auth/auth-context";
import TradeContext from "../../../../../store/tradeState/tradeContext";

const popover = (
  <Popover id="popover-basic">
    <Popover.Title as="h3">The Trade cannot be cancelled manually</Popover.Title>
    <Popover.Content>
      Have you contacted Investec Help Desk (### ### ####) and cancelled the trade manually?
    </Popover.Content>
  </Popover>
);

const errorGroup = [16, 17, 18, 19];

const TradeViewButtonContainer = (props) => {
  const authCtx = useContext(AuthContext);
  const tradeCtx = useContext(TradeContext);

  const { close, tradeId, code, clientView, retryDeal, mailSupport, tryLater, status, trade } = props.props;

  const [show, setShow] = useState(false);

  const [bookedTradeLoading, setBookedTradeLoading] = useState(false);
  const [completeTradeLoading, setCompleteTradeLoading] = useState(false);

  const [showRate, setShowRate] = useState(false);
  const [exchangeRateValue, setExchangeRateValue] = useState(tradeCtx?.trade?.max_exchange_rate) || 0;

  const [tradeIntegration, setTradeIntegration] = useState(true);
  const [tradeView, setTradeView] = useState('summary'); // summary, manual_booking, integration


  const headers = {
    "Acting-as": "dealer",
    Authorization: `JWT ${authCtx?.token}`,
  };

  const handleBookTrade = async () => {
    // Implement the logic for completing the trade
    setShowRate(true);
  };

  const submitTradeBooked = async () => {
    try {
      setBookedTradeLoading(true);
      const body = trade;
      body.exchange_rate = exchangeRateValue;
      body.dealer = authCtx?.correlation_key;
      const compelteTradeRes = await axios.post(`${process.env.REACT_APP_SERVER_URL}/trades/${tradeId}/set_booked/`, body, { headers: headers })

      if(compelteTradeRes.status === 200) {
        // tradeCtx.getTrades();
        // tradeCtx.trades = tradeCtx.trades.find((trade) => trade.id === props.tradeId).trade_status = 1;
        tradeCtx.setShowToast(true);
        tradeCtx.setToastResult('success');
        tradeCtx.setToastMessage('Trade(s) booked successfully');
        tradeCtx.getTrades();
        setBookedTradeLoading(false);
        close();
      }
    } catch (error) {
      console.log('Error completing trade', error);
      setBookedTradeLoading(false);
    }
  }

  const handleExchangeRateChange = (value) => {
    // Allow empty input, 0, just a decimal point, or valid numbers with up to 3 decimal places
    const isValid = (
      value === '' ||                          
      value === '.' ||                      
      /^\d+$/.test(value) ||                 
      /^\d*\.\d{0,4}$/.test(value) ||        
      /^\d+\.$/.test(value)                   
    );
    // const isValid = /^\d+\.\d{2}$/.test(value);
  
    if (isValid) {
      // Only convert to number if it's a valid complete number
      // const numericValue = (value === '' || value.endsWith('.')) 
      //   ? value 
      //   : Number(value);
      setExchangeRateValue(value);
    }
  }

  const handleCloseTrade = async () => {
    setExchangeRateValue(tradeCtx?.trade?.max_exchange_rate) || 0;
    setShowRate(false);
  }

  const handleCompleteTrade = async () => {
    try {
      setCompleteTradeLoading(true);
      const compelteTradeRes = await axios.post(`${process.env.REACT_APP_SERVER_URL}/trades/${tradeId}/set_completed/`, { headers: headers })

      if(compelteTradeRes.status === 200) {
        // tradeCtx.getTrades();
        // tradeCtx.trades = tradeCtx.trades.find((trade) => trade.id === props.tradeId).trade_status = 2;
        setCompleteTradeLoading(false);
        // props.close();
        close();
        tradeCtx.setShowToast(true);
        tradeCtx.setToastResult('success');
        tradeCtx.setToastMessage('Trade(s) completed successfully');
        tradeCtx.getTrades();
      }
    } catch (error) {
      console.log('Error completing trade', error);
      setCompleteTradeLoading(false);
    }
  }


  return (
    <>
      <div className="config_btn_container">
        
        {status === 0 && (
          <OverlayTrigger show={show} key={"top"} placement={"top"} overlay={popover}>
          {/* <Button variant="secondary" onClick={handleSetRateAllow}>Set Rate</Button> */}
          {!showRate ? (
            <Button variant="success" onClick={handleBookTrade} loading={bookedTradeLoading}>
              {bookedTradeLoading ? 'Loading...' : 'Book Trade'}
            </Button>
          ) : <div></div>}
        </OverlayTrigger>
        )}
        {status === 1 && (
          <Button variant="success" onClick={handleCompleteTrade} loading={completeTradeLoading}>
            Complete Trade
          </Button>
        )
}
      </div>
      {/* Rate section */}
      <div className="exchange_rate_confirm_container">
            {showRate && (
              <div className="exchange_rate_content_container">
                <div>
                  <div><label className="form-label">Confirm Exchange Rate</label></div>
                  <input
                    type="text"
                    value={exchangeRateValue}
                    onChange={(event) => handleExchangeRateChange(event.target.value)}
                    placeholder="Enter exchange rate"
                    className="exchange_rate_input"
                  />
                </div>
                <div className="confirm_btn">
                  <Button variant="danger" onClick={handleCloseTrade}>
                    Cancel
                  </Button>
                  <Button variant="success" onClick={submitTradeBooked} loading={bookedTradeLoading}>Confirm</Button>
                </div>

              </div>
            )}
          </div>
    </>
  );
};

TradeViewButtonContainer.propTypes = {
  // code: PropTypes.number,
  // close: PropTypes.func,
  // back: PropTypes.func,
  // cancelTrade: PropTypes.func,
  // clientView: PropTypes.func,
  // retry: PropTypes.func,
  // mailSupport: PropTypes.func,
  // tryLater: PropTypes.func,
  // retryDeal: PropTypes.func,
  // tradeId: PropTypes.number,
  // status: PropTypes.number,
  // trade_status: PropTypes.number,
  // trade: PropTypes.object,
  props: PropTypes.object,
};


export default TradeViewButtonContainer;
